module.exports = __webpack_public_path__ + "static/media/queen.f2b0a2fe.png";